export default {"src":"/_next/static/media/slack-icon-lg.e55b7a02.svg","height":75,"width":80};